<template>
  <div class="box">
    <div class="content-box">
      <el-upload
        class="avatar-uploader quill-img"
        :action="url"
        :show-file-list="true"
        :data="dataUrl"
        name="image"
        :on-success="quillImgSuccess"
        :before-upload="beforeImgUpload"
        style="display: none"
      >
      </el-upload>
      <quill-editor
        ref="QuillEditorFeature"
        v-model="content"
        :options="editorOption"
        @change="onEditorChange($event)"
        style="width: 100%; line-height: normal"
      />
    </div>
    <div class="view-box" v-html="content"></div>
    <el-row style="padding: 20px 0; text-align: left">
      <span style="margin-left: 6px">
        <el-button type="plain" @click="goBack()">取消</el-button>
        <el-button type="primary" @click="update()">保存</el-button>
      </span>
    </el-row>
  </div>
</template>

<script>
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  [{ direction: "rtl" }], // 文本方向
  [{ size: ["small", false, "large", "huge"] }], // 字体大小
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ font: [] }], // 字体种类
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  ["link", "image"], // 链接、图片
];
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "FuncFormsEdit",
  components: {
    quillEditor,
  },
  data() {
    return {
      content: '',
      dataUrl: {
        gym_id: "",
      },
      url:
        "http://admin.meet-fit.com/index.php/admin/coach/coachDetailUploadImg",
      // 富文本上传图片配置
      editorOption: {
        placeholder: "请在这里输入",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
    };
  },
  created() {
    this.getCoachInfo();
    // console.log(this.$router.currentRoute.query.id)
  },
  methods: {
    // 获取教练列表
    getCoachInfo() {
      const params = {
        coach_id: this.$router.currentRoute.query.id,
      };
      this.$http
        .get("index.php/admin/coach/coachDetailShow", { params: params })
        .then((res) => {
          this.content = res.detail;
          this.dataUrl.gym_id = res.gym_id;
        });
    },
    // 取消
    goBack() {
      this.$router.go(-1); //返回上一层
    },
    // 保存
    update() {
      const params = {
        detail: this.content,
        coach_id: this.$router.currentRoute.query.id,
      };
      this.$http
        .post("index.php/admin/coach/coachDetailUpdate", {
          detail: this.content,
          coach_id: this.$router.currentRoute.query.id,
        })
        .then((res) => {
          // console.log(res);
          this.goBack();
        });
    },
    // 富文本编辑框图片上传
    quillImgSuccess(res, file) {
      // console.log(URL.createObjectURL(file.raw));
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.QuillEditorFeature.quill;
      // 如果上传成功
      // console.log(res.Data.path)
      if (res) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.Data.path为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.link);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 上传图片之后
    beforeImgUpload(file) {
      // console.log(file)
    },
    // 内容改变事件
    onEditorChange({ editor, html, text }) {
      this.content = html;
      console.log(this.content)
    },
  },
};
</script>
<style scoped>
</style>
<style>
.box {
  padding: 20px;
  background: #ffffff;
  position: relative;
}
.box .content-box{
  width: 50%;
}
.box .view-box{
  width: 300px;
  height: 455px;
  background: #ffffff;
  text-align: left;
  overflow: auto;
  position: absolute;
  right: 50px;
  top: 20px;
  padding: 15px;
  border: solid 1px #cccccc;
  border-radius: 10px;
}
.box .view-box img{
  width: 50%;
  margin: 0px auto;
  display: block;
}
.box .view-box p{
  text-indent: 25px;
  color: #333333;
}
.ql-toolbar.ql-snow {
  text-align: left;
}
.ql-container.ql-snow {
  height: 400px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}
.ql-align-left {
  text-align: left;
}
</style>